/* Favoritos no carrinho (Caio, 29/10/2026): o "Salvar nos favoritos" entrava dentro da caixa de quantidade
   (o mt-favoritos.js procura o link com quantity=0 e, com 1 unidade, o botao "-" tambem tem esse link).
   Aqui o botao sai da caixa e vai para uma linha propria, logo abaixo da quantidade e do Remover. */
(function () {
  function arruma() {
    document.querySelectorAll('.quantity-selector > .mt-fav-salvar').forEach(function (b) {
      var q = b.closest('line-item-quantity') || b.closest('.quantity-selector');
      if (q && q.parentNode) q.parentNode.insertBefore(b, q.nextSibling);
      b.classList.add('mt-fav-salvar--linha');
    });
  }
  var st = document.createElement('style');
  st.textContent = '.mt-fav-salvar--linha{display:block;margin-top:2px;text-align:left}';
  document.head.appendChild(st);
  arruma();
  new MutationObserver(arruma).observe(document.documentElement, { childList: true, subtree: true });
})();
